import { ref } from 'vue';
import { APP_VERSION, VERSION_STORAGE_KEY } from '@/constants';
import Swal from 'sweetalert2';

export function useVersionManager() {
  const isVersionValid = ref(true);
  const currentVersion = ref(APP_VERSION);
  const storedVersion = ref(localStorage.getItem(VERSION_STORAGE_KEY));

  const checkVersion = () => {
    const stored = localStorage.getItem(VERSION_STORAGE_KEY);
    const current = APP_VERSION;
    
    storedVersion.value = stored;
    currentVersion.value = current;
    
    return stored === current;
  };

  const updateStoredVersion = () => {
    localStorage.setItem(VERSION_STORAGE_KEY, APP_VERSION);
    storedVersion.value = APP_VERSION;
  };

  const showUpdateNotification = async () => {
    const result = await Swal.fire({
      title: '¡Nueva versión disponible!',
      html: `
        <div class="text-left">
          <p class="mb-4">Se ha detectado una nueva versión de la aplicación.</p>
          <p class="text-gray-600 text-sm mb-2">
            <strong>Versión anterior:</strong> ${storedVersion.value || 'No detectada'}
          </p>
          <p class="text-gray-600 text-sm mb-4">
            <strong>Versión actual:</strong> ${currentVersion.value}
          </p>
          <p class="text-gray-600 text-sm">
            Actualizando la aplicación...
          </p>
        </div>
      `,
      icon: 'info',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Entendido',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    
    return result.isConfirmed;
  };

  const forceUpdate = () => {
    const keysToPreserve = ['theme', 'language'];
    const allKeys = Object.keys(localStorage);
    
    allKeys.forEach(key => {
      if (!keysToPreserve.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    
    updateStoredVersion();
    
    window.location.reload();
  };

  const handleVersionCheck = async (showNotification = true) => {
    const isValid = checkVersion();
    isVersionValid.value = isValid;
    
    if (!isValid) {
      console.warn(`Versión desactualizada: ${storedVersion.value} -> ${currentVersion.value}`);
      
      if (showNotification) {
        await showUpdateNotification();
      }
      
      return false;
    }
    
    if (!storedVersion.value) {
      updateStoredVersion();
    }
    
    return true;
  };

  return {
    isVersionValid,
    currentVersion,
    storedVersion,
    checkVersion,
    updateStoredVersion,
    showUpdateNotification,
    forceUpdate,
    handleVersionCheck
  };
} 